import React, { Component } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import Link from "gatsby-link";

//Para internacionalización
import { getCurrentLangKey, getLangs, getUrlForLang } from "ptz-i18n";
import { IntlProvider } from "react-intl";
import "intl";

import "../assets/sass/main.scss";

import NavigationBar from "../components/NavigationBar";
import Menu from "../components/Menu";
import Footer from "../components/Footer";

import favicon from "../images/favicon.ico";

class Layout extends Component {
  state = {
    isMenuOpen: false
  };

  constructor(props) {
    super(props);
  }

  openMenu = e => {
    e.preventDefault();
    this.setState({ isMenuOpen: true });
  };

  closeMenu = e => {
    e.preventDefault();
    this.setState({ isMenuOpen: false });
  };

  render() {
    const { children, data, location, i18nMessages } = this.props;
    const url = location.pathname;
    const { langs, defaultLangKey } = data.site.siteMetadata.languages;
    const langKey = getCurrentLangKey(langs, defaultLangKey, url);
    const homeLink = `/${langKey}/`;
    const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, url));
    return (
      <IntlProvider locale={langKey} messages={i18nMessages}>
        <div>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              { name: "Ewwo Consulting", content: "Empresa de desarrollo" },
              {
                name: "keywords",
                content:
                  "desarrollo, programacion, development, programming, frontend, backend, fullstack, javascript, php, angularjs, react, reactjs, graphql, gatsbyjs, sindicato, sindicatos, obra social, obras sociales, sistema, sistemas, IT, mutual, o.s., hmo, health care, system"
              }
            ]}
            link={[
              { rel: "shortcut icon", type: "image/png", href: `${favicon}` }
            ]}
          >
            <html lang="en" />
          </Helmet>
          {location.pathname !== "/" && (
            <NavigationBar
              siteTitle={data.site.siteMetadata.title}
              openMenu={this.openMenu}
              langs={langsMenu}
              language={langKey}
            />
          )}
          <div className={this.state.isMenuOpen ? "is-menu-visible" : ""}>
            <div
              id="page-wrapper"
              onClick={this.state.isMenuOpen ? this.closeMenu : undefined}
            >
              {children({
                ...this.props,
                openMenu: this.openMenu,
                langs: langsMenu,
                language: langKey
              })}
              <Footer langs={langsMenu} language={langKey} />
            </div>
            <Menu closeMenu={this.closeMenu} langs={langsMenu}>
              <Link to={`/${langKey}/`}>Home</Link>
              <Link to={`/${langKey}/About`}>
                {langKey === "en" ? "About us" : "Nosotros"}
              </Link>
              <Link to={`/${langKey}/Consulting`}>Consulting</Link>
              {langKey === "en" ? null : (
                <Link to={`/es/Services`}>Servicios a Sindicatos y O.S.</Link>
              )}
              <Link to={`/${langKey}/Outsourcing`}>Outsourcing</Link>
            </Menu>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.func
};

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        languages {
          defaultLangKey
          langs
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js